import usePageTracking from "@/lib/usePageTracking";

/**
 * Silent component that fires a GA4 page_view on every SPA route change.
 * Placed inside <BrowserRouter/> so it can read useLocation().
 */
export default function AnalyticsRouter() {
  usePageTracking();
  return null;
}
